import { makeStyles } from "@material-ui/core/styles";

// 🎨 Estilos para Componentes de Mídia - WhatsApp 2.0 Design
export const useMediaStyles = makeStyles((theme) => ({
  // 🏗️ Container principal de mídia
  mediaContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: '360px',
    borderRadius: '12px',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
    // boxShadow: '0 1px 2px rgba(0, 0, 0, 0.15)',
    // transition: 'all 0.2s ease-in-out',
    // '&:hover': {
    //   boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
    //   transform: 'translateY(-1px)',
    // },
  },

  // 🖼️ Container de imagem
  imageContainer: {
    position: 'relative',
    width: '100%',
    cursor: 'pointer',
    '&:hover $imageOverlay': {
      opacity: 1,
    },
    '&:hover $downloadChip': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },

  // 🖼️ Imagem responsiva
  mediaImage: {
    width: '100%',
    height: 'auto',
    maxHeight: '300px',
    objectFit: 'contain',
    display: 'block',
    transition: 'transform 0.3s ease-in-out',
    borderRadius: '12px',
    '&:hover': {
      transform: 'scale(1.02)',
    },
  },

  // 🎭 Overlay para imagem
  imageOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.1))',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transition: 'opacity 0.3s ease-in-out',
    borderRadius: '12px',
  },

  // 💾 Botão de download hover (chip no canto direito inferior)
  downloadChip: {
    position: 'absolute',
    bottom: '8px',
    right: '8px',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    color: 'white',
    padding: '6px 12px',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '12px',
    fontWeight: 500,
    opacity: 0,
    transform: 'translateY(10px)',
    transition: 'all 0.3s ease-in-out',
    cursor: 'pointer',
    backdropFilter: 'blur(4px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      transform: 'translateY(0) scale(1.05)',
    },
    // Fallback para dispositivos touch
    '@media (hover: none)': {
      opacity: 0.8,
      transform: 'translateY(0)',
    },
  },

  // 💾 Ícone do download chip
  downloadChipIcon: {
    fontSize: '16px',
  },

  // 🔍 Ícone de zoom
  zoomIcon: {
    color: 'white',
    fontSize: '2rem',
    filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5))',
  },

  // 🎥 Container de vídeo
  videoContainer: {
    position: 'relative',
    width: '100%',
    borderRadius: '12px',
    overflow: 'hidden',
    transition: 'transform 0.2s ease-in-out',
    '&:hover $downloadChip': {
      opacity: 1,
      transform: 'translateY(0)',
    },
    '&:hover $videoOverlay': {
      opacity: 1,
    },
    '&:hover': {
      transform: 'scale(1.02)',
    },
  },

  // 🎥 Elemento de vídeo (sem controles na conversa)
  mediaVideo: {
    width: '100%',
    maxHeight: '300px',
    objectFit: 'cover',
    borderRadius: '12px',
    cursor: 'pointer',
    '&:focus': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: '2px',
    },
  },

  // 🎭 Overlay para vídeo (play button)
  videoOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.1))',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transition: 'opacity 0.3s ease-in-out',
    borderRadius: '12px',
  },

  // ▶️ Play button grande no centro
  playButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    color: theme.palette.primary.main,
    borderRadius: '50%',
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'white',
      transform: 'scale(1.1)',
      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.4)',
    },
  },

  // ▶️ Ícone do play
  playIcon: {
    fontSize: '20px',
    marginLeft: '2px', // Ajuste visual para centralizar
  },

  // 🎵 Container de áudio
  audioContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    backgroundColor: theme.palette.background.default,
    borderRadius: '12px',
    border: `1px solid ${theme.palette.divider}`,
    minHeight: '60px',
    gap: '12px',
  },

  // 🎵 Ícone de áudio
  audioIcon: {
    fontSize: '1.5rem',
    color: theme.palette.primary.main,
  },

  // 🎵 Informações de áudio
  audioInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },

  // 🎵 Título do áudio
  audioTitle: {
    fontSize: '0.9rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginBottom: '4px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  // 🎵 Duração do áudio
  audioDuration: {
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
  },

  // 📎 Container de arquivo
  fileContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    backgroundColor: theme.palette.background.default,
    borderRadius: '12px',
    border: `1px solid ${theme.palette.divider}`,
    gap: '12px',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.primary.main,
    },
  },

  // 📎 Ícone de arquivo
  fileIcon: {
    fontSize: '2rem',
    color: theme.palette.primary.main,
  },

  // 📎 Informações de arquivo
  fileInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    alignItems: 'flex-start',
  },

  // 📎 Nome do arquivo
  fileName: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: '4px',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    lineHeight: 1.3,
    wordBreak: 'break-word',
  },

  // 📎 Tipo do arquivo
  fileType: {
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },

  // 📎 Botão de download
  downloadButton: {
    minWidth: 'auto',
    padding: '8px',
    borderRadius: '50%',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },

  // 📍 Container de localização
  locationContainer: {
    borderRadius: '12px',
    overflow: 'hidden',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
    },
  },

  // 📇 Container de contato
  contactContainer: {
    padding: '16px',
    backgroundColor: theme.palette.background.default,
    borderRadius: '12px',
    border: `1px solid ${theme.palette.divider}`,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.primary.main,
    },
  },
  // 🎯 Container de contato quoted (compacto)
  quotedContactContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    backgroundColor: theme.palette.background.default,
    borderRadius: '6px',
    border: `1px solid ${theme.palette.divider}`,
    gap: '8px',
    maxWidth: '200px',
    overflow: 'hidden',
  },

  // 🎯 Container de contato preview (muito compacto)
  previewContactContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px',
    backgroundColor: theme.palette.background.default,
    borderRadius: '4px',
    border: `1px solid ${theme.palette.divider}`,
    gap: '6px',
    maxWidth: '150px',
    overflow: 'hidden',
  },

  // 📇 Ícone de contato
  contactIcon: {
    fontSize: '1.2rem',
    color: theme.palette.primary.main,
    flexShrink: 0,
  },

  // 📇 Informações de contato
  contactInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },

  // 📇 Nome do contato
  contactName: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '0.875rem',
  },

  // 📇 Número do contato
  contactNumber: {
    color: theme.palette.text.secondary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '0.75rem',
  },

  // 🚫 Estado de erro
  errorContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    backgroundColor: theme.palette.error.light,
    borderRadius: '12px',
    border: `1px solid ${theme.palette.error.main}`,
    color: theme.palette.error.contrastText,
  },

  // ⏳ Estado de carregamento
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    backgroundColor: theme.palette.action.hover,
    borderRadius: '12px',
    border: `1px solid ${theme.palette.divider}`,
  },

  // 🔄 Spinner de carregamento
  loadingSpinner: {
    color: theme.palette.primary.main,
  },

  // 🎯 Container para imagem quoted (menor - proporção 1:1)
  quotedImageContainer: {
    position: 'relative',
    width: '80px',
    height: '80px',
    cursor: 'pointer',
    borderRadius: '8px',
    overflow: 'hidden',
    flexShrink: 0,
    boxSizing: 'border-box',
    padding: 0,
    margin: 0,
    '&:hover': {
      opacity: 0.9,
    },
  },

  // 🎯 Container para imagem preview (muito pequeno - proporção 1:1)
  previewImageContainer: {
    position: 'relative',
    width: '50px',
    height: '50px',
    borderRadius: '6px',
    overflow: 'hidden',
    marginRight: theme.spacing(1),
    flexShrink: 0,
    boxSizing: 'border-box',
    padding: 0,
  },

  // 🎯 Imagem quoted (mesma lógica das normais)
  quotedImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    display: 'block',
    borderRadius: '8px',
    margin: 0,
    padding: 0,
    border: 'none',
    outline: 'none',
  },

  // 🎯 Imagem preview (mesma lógica das normais)
  previewImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    display: 'block',
    borderRadius: '6px',
    margin: 0,
    padding: 0,
    border: 'none',
    outline: 'none',
  },

  // 🎯 Container para vídeo quoted (menor - proporção 1:1)
  quotedVideoContainer: {
    position: 'relative',
    width: '80px',
    height: '80px',
    borderRadius: '8px',
    overflow: 'hidden',
    flexShrink: 0,
    boxSizing: 'border-box',
    padding: 0,
    margin: 0,
    '&:hover': {
      opacity: 0.9,
    },
  },

  // 🎯 Container para vídeo preview (muito pequeno - proporção 1:1)
  previewVideoContainer: {
    position: 'relative',
    width: '50px',
    height: '50px',
    borderRadius: '6px',
    overflow: 'hidden',
    marginRight: theme.spacing(1),
    flexShrink: 0,
    boxSizing: 'border-box',
    padding: 0,
  },

  // 🎯 Vídeo quoted (mesma lógica dos normais)
  quotedVideo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    borderRadius: '8px',
    margin: 0,
    padding: 0,
    border: 'none',
    outline: 'none',
  },

  // 🎯 Vídeo preview (mesma lógica dos normais)
  previewVideo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    borderRadius: '6px',
    margin: 0,
    padding: 0,
    border: 'none',
    outline: 'none',
  },

  // 📱 Responsividade mobile
  '@media (max-width: 600px)': {
    mediaContainer: {
      maxWidth: '280px',
    },
    mediaImage: {
      maxHeight: '200px',
    },
    mediaVideo: {
      maxHeight: '200px',
    },
    // ▶️ Play button menor em mobile
    playButton: {
      width: '40px',
      height: '40px',
    },
    playIcon: {
      fontSize: '16px',
    },
    downloadChip: {
      padding: '4px 8px',
      fontSize: '11px',
    },
    audioContainer: {
      padding: '12px',
    },
    fileContainer: {
      padding: '12px',
    },
    contactContainer: {
      padding: '12px',
    },
  },

  // 🌙 Modo escuro
  '@media (prefers-color-scheme: dark)': {
    mediaContainer: {
      backgroundColor: theme.palette.grey[900],
      boxShadow: '0 1px 3px rgba(255, 255, 255, 0.1)',
    },
    audioContainer: {
      backgroundColor: theme.palette.grey[800],
    },
    fileContainer: {
      backgroundColor: theme.palette.grey[800],
    },
    contactContainer: {
      backgroundColor: theme.palette.grey[800],
    },
  },
}));

export default useMediaStyles;
